import MobileConfigUpdateFlow from 'component/MobileConfigUpdate/components/MobileConfigUpdateFlow'
import { useEffect, useState } from 'react'
import { isCurrentEntryHostOutdated } from './domain'
import { TooltipButton, TooltipText, TooltipWrapper } from './Styled'

export default function EntryDomainUpdateTooltip() {
  const [visible, setVisible] = useState(false)
  const [updateFlowOpened, setUpdateFlowOpened] = useState(false)

  useEffect(() => {
    let cancelled = false

    isCurrentEntryHostOutdated()
      .then((isOutdated) => {
        if (!cancelled) {
          setVisible(isOutdated)
        }
      })
      .catch((err) => {
        console.warn('[entry domain update] skipped stale domain check', err)
      })

    return () => {
      cancelled = true
    }
  }, [])

  if (!visible && !updateFlowOpened) return null

  return (
    <>
      {visible && (
        <TooltipWrapper>
          <TooltipText>系统检测线路过旧，请更新至最新版</TooltipText>
          <TooltipButton onClick={() => setUpdateFlowOpened(true)}>前往更新</TooltipButton>
        </TooltipWrapper>
      )}
      <MobileConfigUpdateFlow isOpen={updateFlowOpened} onClose={() => setUpdateFlowOpened(false)} />
    </>
  )
}
